import { mirandaMediaArray } from './mirandaMedia'
import { mirandaBio } from './mirandaBios'
import { carrieProfileReviewHinge, charlotteProfileReviewBumble, samanthaProfileReviewTinder } from './mirandaProfileReviews'

export const mirandaDatingProfileHinge = {
  _id: 'mirandaDatingProfileHingeId',
  userId: 'mirandaUserId',
  email: 'miranda@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: mirandaMediaArray[2]._id,
      mediaItemURL: mirandaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[2].type,
      caption: mirandaMediaArray[2].captions[1],
      subcaption: mirandaMediaArray[2].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[8]._id,
      mediaItemURL: mirandaMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[8].type,
      caption: mirandaMediaArray[8].captions[1],
      subcaption: mirandaMediaArray[8].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[6]._id,
      mediaItemURL: mirandaMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[6].type,
      caption: mirandaMediaArray[6].captions[0],
      subcaption: mirandaMediaArray[6].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[7]._id,
      mediaItemURL: mirandaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[7].type,
      caption: mirandaMediaArray[7].captions[0],
      subcaption: mirandaMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[13]._id,
      mediaItemURL: mirandaMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[13].type,
      caption: mirandaMediaArray[13].captions[0],
      subcaption: mirandaMediaArray[13].subcaptions[0],
    },
    {
      mediaItemId: mirandaMediaArray[12]._id,
      mediaItemURL: mirandaMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[12].type,
      caption: mirandaMediaArray[12].captions[1],
      subcaption: mirandaMediaArray[12].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: mirandaBio._id,
    vitalInfo: { ...mirandaBio.vitalInfo },
    prompts: [
      { ...mirandaBio.prompts[0] },
      { ...mirandaBio.prompts[1] },
      { ...mirandaBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...carrieProfileReviewHinge }
  ],
  mediaItems: [ ...mirandaMediaArray ],
  bioItems: { ...mirandaBio },
}

export const mirandaDatingProfileBumble = {
  _id: 'mirandaDatingProfileBumbleId',
  userId: 'mirandaUserId',
  email: 'miranda@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: mirandaMediaArray[2]._id,
      mediaItemURL: mirandaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[2].type,
      caption: mirandaMediaArray[2].captions[1],
      subcaption: mirandaMediaArray[2].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[8]._id,
      mediaItemURL: mirandaMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[8].type,
      caption: mirandaMediaArray[8].captions[1],
      subcaption: mirandaMediaArray[8].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[6]._id,
      mediaItemURL: mirandaMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[6].type,
      caption: mirandaMediaArray[6].captions[0],
      subcaption: mirandaMediaArray[6].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[7]._id,
      mediaItemURL: mirandaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[7].type,
      caption: mirandaMediaArray[7].captions[0],
      subcaption: mirandaMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[13]._id,
      mediaItemURL: mirandaMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[13].type,
      caption: mirandaMediaArray[13].captions[0],
      subcaption: mirandaMediaArray[13].subcaptions[0],
    },
    {
      mediaItemId: mirandaMediaArray[12]._id,
      mediaItemURL: mirandaMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[12].type,
      caption: mirandaMediaArray[12].captions[1],
      subcaption: mirandaMediaArray[12].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: mirandaBio._id,
    vitalInfo: { ...mirandaBio.vitalInfo },
    prompts: [
      { ...mirandaBio.prompts[0] },
      { ...mirandaBio.prompts[1] },
      { ...mirandaBio.prompts[2] }
    ],
    aboutMe: mirandaBio.aboutMe[0],
    hobbies: [mirandaBio.hobbies[0], mirandaBio.hobbies[1], mirandaBio.hobbies[2], mirandaBio.hobbies[3], mirandaBio.hobbies[4] ],
  },
  profileReviews: [
    { ...charlotteProfileReviewBumble }
  ],
  mediaItems: [ ...mirandaMediaArray ],
  bioItems: { ...mirandaBio },
}

export const mirandaDatingProfileTinder = {
  _id: 'mirandaDatingProfileTinderId',
  userId: 'mirandaUserId',
  email: 'miranda@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: mirandaMediaArray[2]._id,
      mediaItemURL: mirandaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[2].type,
      caption: mirandaMediaArray[2].captions[1],
      subcaption: mirandaMediaArray[2].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[8]._id,
      mediaItemURL: mirandaMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[8].type,
      caption: mirandaMediaArray[8].captions[1],
      subcaption: mirandaMediaArray[8].subcaptions[1],
    },
    {
      mediaItemId: mirandaMediaArray[6]._id,
      mediaItemURL: mirandaMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[6].type,
      caption: mirandaMediaArray[6].captions[0],
      subcaption: mirandaMediaArray[6].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[7]._id,
      mediaItemURL: mirandaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[7].type,
      caption: mirandaMediaArray[7].captions[0],
      subcaption: mirandaMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: mirandaMediaArray[13]._id,
      mediaItemURL: mirandaMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[13].type,
      caption: mirandaMediaArray[13].captions[0],
      subcaption: mirandaMediaArray[13].subcaptions[0],
    },
    {
      mediaItemId: mirandaMediaArray[12]._id,
      mediaItemURL: mirandaMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: mirandaMediaArray[12].type,
      caption: mirandaMediaArray[12].captions[1],
      subcaption: mirandaMediaArray[12].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: mirandaBio._id,
    vitalInfo: { ...mirandaBio.vitalInfo },
    prompts: [
      { ...mirandaBio.prompts[0] },
      { ...mirandaBio.prompts[1] },
      { ...mirandaBio.prompts[2] }
    ],
    aboutMe: mirandaBio.aboutMe[0],
    hobbies: [mirandaBio.hobbies[0], mirandaBio.hobbies[1], mirandaBio.hobbies[2], mirandaBio.hobbies[3], mirandaBio.hobbies[4] ],
  },
  profileReviews: [
    { ...samanthaProfileReviewTinder }
  ],
  mediaItems: [ ...mirandaMediaArray ],
  bioItems: { ...mirandaBio },
}